export enum Mode {
  CAMERA = 'CAMERA',
  CAMERA_RELOCATE = 'CAMERA_RELOCATE',
  FILE = 'FILE',
  FILE_PREVIEW = 'FILE_PREVIEW',
  PREVIEW = 'PREVIEW',
  WORKING = 'WORKING',
}

export enum ItemType {
  FILE = 'FILE',
  FOLDER = 'FOLDER',
}

export default {
  ItemType,
  Mode,
};
